<div class="modal-content">
    <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"  novalidate #frm="ngForm" (ngSubmit)="onSubmit()">
      <div #pnl class="modal-body">
        <div class="alert alert-success alert-dismissible" *ngIf="mensagemSucesso" class="mt-2">
          <button type="button" class="close" (click)="fecheMensagemSucesso()">
            <span>&times;</span>
          </button>
          <i class="mdi mdi-check-all mr-2"></i> {{mensagemSucesso}}
        </div>

        <div class="alert alert-danger alert-dismissible" *ngIf="mensagemErro" class="mt-2">
          <button type="button" class="close" (click)="fecheMensagemErro()">
            <span>&times;</span>
          </button>
          <i class="mdi mdi-check-all mr-2"></i> {{mensagemErro}}
        </div>

        <div class="form-group mb-3">
          <label for="nome">Nome da Categoria</label>
          <input type="text" class="form-control" autocomplete="off"
                 id="nome" name="nome" [(ngModel)]="categoria.nome" #nome="ngModel"
                 (change)="categoria.nome = categoria.nome.trim()"
                 placeholder="Nome da categoria" value="" required appAutoFocus [autoFocus]="true">
          <div class="invalid-feedback">
            <p *ngIf="nome.errors?.required">Nome é obrigatório</p>
          </div>
        </div>

        <div class="form-group mb-3">
          <label for="formatoVitrine">Desenho da prateleira na loja</label>
          <select class="form-control" id="formatoVitrine" name="formatoVitrine"
                  [(ngModel)]="categoria.formatoVitrine">
            <option [ngValue]="null">Automático (a loja escolhe pelo conteúdo)</option>
            <option value="lista">Lista — uma linha por item, com espaço para o texto</option>
            <option value="grade">Grade — cards lado a lado, foto em destaque</option>
            <option value="vitrine">Vitrine — poucos itens, cada um em tamanho grande</option>
            <option value="linha">Linha — itens sem foto, o mais compacto</option>
            <option value="impresso">Impresso — nome ···· preço, como cardápio de papel</option>
          </select>
          <small class="text-muted d-block mt-1">{{motivoDoFormato}}</small>
        </div>

        <app-upload-crop-imagem #categoriarUpload ratio="1"  widthExibir="250"
                                *ngIf="empresa.cardapio && empresa.cardapio.exibirSelecaoCategorias"
                                resizeWidth="400" minWidth="400" minHeight="400" [confirmarSalvar]="false"
                                [objeto]="categoria"  [prop]="'imagem'" [label]="'Foto'"  >
        </app-upload-crop-imagem>

        <div *ngIf=" empresa?.id && areasDestino?.length">
          <fieldset>
            <legend> <i class="fa fa-desktop mr-1"></i> Tela KDS </legend>

            <h5>Enviar automaticamente para os destinos</h5>

            <div class="form-group    ">
              <div class="row mt-2">
                <div class="col-6" *ngFor="let areaDestino of areasDestino; let i = index;"  >
                  <div class="form-group mb-3">
                    <label class="k-checkbox-label">
                      <input type="checkbox" name="areaDestino{{i}}" class="k-checkbox " kendoCheckBox
                             [(ngModel)]="areaDestino.disponivel" [disabled]="areaDestino.imprimirAutomatico" />
                      {{areaDestino.nome}}</label>

                  </div>
                </div>
              </div>
              <div class=" note alert alert-info">
                <strong>💡 Dica:</strong> Para vincular uma categoria a uma area destino ela  nao deve estar marcada como
                <b>enviar automático</b>
              </div>
            </div>
          </fieldset>

        </div>

        <div *ngIf="empresa && empresa.configImpressao && empresa.configImpressao.multiplasImpressoras && possuiRecursoImpressaoAvancada()">
          <fieldset>
            <legend> <i class="fa fa-print mr-1"></i> Impressoras</legend>
            <h5>Imprimir automaticamente nos setores</h5>
            <div class="form-group">
              <div class="row mt-2">
                <div class="col-6" *ngFor="let impressora of impressoras; let i = index;" [hidden]="impressora.ocultar">
                  <div class="form-group mb-3">
                    <label class="k-checkbox-label">
                      <input type="checkbox" name="disponivel{{i}}" class="k-checkbox " kendoCheckBox
                             [(ngModel)]="impressora.disponivel" [disabled]="impressora.imprimirAutomatico" />
                      {{impressora.setor}}</label>

                    <!--<small *ngIf="impressora.imprimirAutomatico" class="text-muted">
                      <br><i>já configurado imprimir automatico</i>
                    </small> -->
                  </div>
                </div>
              </div>

              <div class=" note alert alert-info">
                <strong>💡 Dica:</strong> Para vincular uma categoria a uma impressa ela precisa estar configurada com <b>layout resumido</b>
                e nao deve estar marcada como <b>imprimir automatico</b>
              </div>

            </div>
          </fieldset>
        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="salvando"  >
            Salvar <i class="k-icon k-i-loading ml-1" *ngIf="salvando"> </i>
          </button>
          <button type="button" class="btn btn-light waves-effect" data-dismiss="modal"
                  (click)="feche(null)">Fechar</button>
        </div>

      </div>
  </form>
</div>
